/**
 * Check if the passed data is a string. This is just a basic validation,
 * not a replacement for proper server-side validation
 *
 * @constant
 * @param fileData data to check for being an image or not.
 */
export const isImage = (fileData) => {
    return (fileData && fileData.indexOf('image/') > 0) || false;
};
